import React from 'react';
import Link from 'next/link';
import ArrowRight from '@clearkit/icons/glyphs/ArrowRight';
import { IResourcesListItem } from 'interfaces';
import Authors from './Authors';
import CoverImage from './CoverImage';

function ItemsList({
  items,
  title,
  allItemsUrl,
  urlFn,
}: {
  items: IResourcesListItem[];
  title?: string;
  allItemsUrl?: string;
  urlFn: (slug: string, tag?: string) => string;
}): React.ReactElement | null {
  if (!items.length) {
    return null;
  }

  return (
    <div className="main-container">
      <div className="flex items-center justify-between mb-8">
        {!!title && <div className="ck-h3 my-0 font-semibold">{title}</div>}
        {!!allItemsUrl && (
          <div>
            <Link href={allItemsUrl}>
              <a className="hover:scale-105 inline-block duration-300 transform cursor-pointer">
                <div className="w-full">
                  <span className="ck-button--tertiary--blue inline-block p-0 font-medium">
                    <span className="inline-block">View all</span>
                    <ArrowRight className="inline-block w-4 ml-1 -mt-1" />
                  </span>
                </div>
              </a>
            </Link>
          </div>
        )}
      </div>
      <div className="lg:flex lg:-mx-4 flex-wrap justify-start">
        {items.map(({ slug, date, title: itemTitle, description, authors, cta, image, tag }) => {
          return (
            <div key={slug} className="lg:w-1/3 lg:px-4 w-full mb-4">
              <Link href={urlFn(slug, tag)}>
                <a className="hover:scale-105 relative flex flex-row w-full h-full p-6 text-gray-900 duration-300 transform bg-white border border-gray-100 cursor-pointer">
                  <div className={`pb-16 w-full ${image ? ' pt-64' : ''}`}>
                    {!!image && (
                      <CoverImage
                        classNames="absolute top-0 left-0 right-0 h-64 object-cover object-top bg-white"
                        image={image}
                      />
                    )}
                    {!!tag && (
                      <div className="mt-1 mb-4">
                        <span className="text-[0.625rem] leading-none inline-block px-2 py-1 text-gray-400 uppercase border border-gray-400 rounded">
                          {tag}
                        </span>
                      </div>
                    )}
                    {!!date && <p className="text-2xs font-semibold text-gray-400">{date}</p>}
                    <h4 className="my-1 text-xl font-semibold">{itemTitle}</h4>
                    <p className="text-md line-clamp-5 leading-loose text-gray-600">{description}</p>
                    <Authors authors={authors} />
                    <span className="ck-button--tertiary--blue bottom-8 left-6 absolute inline-block p-0 font-medium">
                      <span className="inline-block mt-4">{cta}</span>
                      <ArrowRight className="inline-block w-4 ml-1 -mt-1" />
                    </span>
                  </div>
                </a>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
}
ItemsList.defaultProps = {
  title: undefined,
  allItemsUrl: undefined,
};

export default ItemsList;
